// import { NGX_MAT_DATE_FORMATS, NgxMatDateAdapter, NgxMatDateFormats, NgxMatNativeDateAdapter } from '@angular-material-components/datetime-picker';
import { Injectable } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS, NativeDateAdapter } from '@angular/material/core';
import { MatDateFormats } from '@angular/material/core';

@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
    format(date: Date, displayFormat: Object): string {
        if (displayFormat === 'DD-MMM-YYYY') {
            const year = date.getFullYear();
            const monthAbbr = date.toLocaleString('en-US', { month: 'short' }).toUpperCase();
            const day = this._to2digit(date.getDate());
            return `${day}-${monthAbbr}-${year}`;
        } else if (displayFormat === 'DD/MMM/YYYY, HH:mm:ss') {
            const year = date.getFullYear();
            const monthAbbr = date.toLocaleString('en-US', { month: 'short' }).toUpperCase();
            const day = this._to2digit(date.getDate());
            const hours = this._to2digit(date.getHours());
            const minutes = this._to2digit(date.getMinutes());
            const seconds = this._to2digit(date.getSeconds());

            return `${day}-${monthAbbr}-${year}, ${hours}:${minutes}:${seconds}`;
        }
        return date.toDateString();
    }

    private _to2digit(n: number): string {
        return ('00' + n).slice(-2);
    }
}

export const DateProviders = [
    { provide: DateAdapter, useClass: CustomDateAdapter },
    // { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS },
    // { provide: NgxMatDateAdapter, useClass: ngxCustomDateAdapter },
    // { provide: NGX_MAT_DATE_FORMATS, useValue: ngxCUSTOM_DATE_FORMATS },
];
